import { render, staticRenderFns } from "./RepaymentsControllers.vue?vue&type=template&id=6449ca84&scoped=true&"
import script from "./RepaymentsControllers.vue?vue&type=script&lang=js&"
export * from "./RepaymentsControllers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449ca84",
  null
  
)

export default component.exports